import React from 'react';
import InsightsComponent from '../components/Insights/Insights';

/**
 * InsightsPage - Insights listing page wrapper
 */
export default function InsightsPage() {
  return <InsightsComponent />;
}
